import { useDispatch } from 'react-redux';
import { openWithData, close, setOpen, setData } from '../features/twilioPhoneSlice';

export const useTwilioPhone = () => {
  const dispatch = useDispatch();

  const openPhone = () => {
    dispatch(setOpen(true));
  };

  const closePhone = () => {
    dispatch(close());
  };

  const openWithClientAndQuote = (client, quoteId) => {
    dispatch(openWithData({ client, quoteId }));
  };

  const setPhoneData = (client, quoteId) => {
    dispatch(setData({ client, quoteId }));
  };

  return {
    openPhone,
    closePhone,
    openWithClientAndQuote,
    setPhoneData,
  };
};
